// Webpack Imports
import * as bootstrap from 'bootstrap';
// import Swiper JS
// import Swiper from 'swiper';
import Swiper from 'swiper/bundle';
import { Navigation, Pagination } from 'swiper/modules';

( function () {
	'use strict';

	function debounce(func, timeout = 500){
		let timer
		return (...args) => {
			clearTimeout(timer)
			timer = setTimeout(() => func.apply(this, args), timeout)
		}
	}

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	$(document).on('submit','form.cart', function(e){
		e.preventDefault()
		submitForm( new FormData(e.target) )
	});

	$(document.body).on('click', '.quantity-counter .increment', function() {
		
		// Enhances number input adding increment buttons
		let dir = $(this).attr('direction')
		let input = $(this).closest('.quantity-counter').find('input')[0]
		let value = input.value

		if(dir =='up')  {
			value++
		}

		if(dir =='down')  {
			if(value > 1) {
				value--
			}
		}

		input.value = value
		$(input).trigger('change')
	})

	let floatingCart = {
		refreshFragments(fragments){
			$.each(fragments, (key, value) =>  $(key).replaceWith(value) );
		},
		el: $('.floating-cart'),
		init(){
			$(document.body).on('click', '.floating-cart-close-button', () => this.close() )
			$(document.body).on('click', '.floating-cart-open-button', () => this.open() )
			$(document.body).on('click', '.floating-cart-toggle-button', () => this.toggle() )
			$(document.body).on('change', '.floating-cart .quantity-input', this.updateQuantity)
		},
		updateQuantity: debounce( async(el) => {

			let $input = el.target
			let key = $input.getAttribute('cart-key')
			let quantity = $input.value
			floatingCart.busy()
			let res = await $.post('?wc-ajax=cart/update-quantity', {
				key, 
				quantity
			})
			floatingCart.refreshFragments(res.fragments)
			floatingCart.ready()
		}),
		toggle(){
			if( this.el.length == 0 ) {
				window.location = "/cart"
			}
			this.el.hasClass('open') ? this.close() : this.open()
		},
		ready() {
			this.el.removeClass('busy')
		},
		busy(){
			this.el.addClass('busy')
		},
		refresh( cb = () => {} ){
			this.busy()
			/**
				Take a CB fn that is fired once event concludes.
				Binds temporary fn to apply logic
			*/
			let fn = () => {
				$( document.body ).off( 'wc_fragments_refreshed', fn)	
				cb()
				this.ready()
			}
			$( document.body ).on( 'wc_fragments_refreshed', fn)
			$( document.body ).trigger( 'wc_fragment_refresh' )
		},
		open() {
			if( this.el.length == 0 ) {
				return;
			}
			this.el.addClass('open')
			$('body').addClass('noscroll');
		},
		_close(){
			this.el.removeClass('open');
			$('body').removeClass('noscroll');
		},
		close(delay = 0){
			setTimeout(() => this._close(), delay)
		}
	}
	floatingCart.init();
	
	let submitForm = async(data) => {
		
		$('form.cart').addClass('loading');

		$('form.cart .loading-container').attr('loading', true);

		data.append('action', 'woo-product-add-to-cart');

		let res = await $.ajax({
            type: 'POST',
            url: fweb.ajax_url,
			processData: false,
			contentType: false,
            data,
        });

		let response = JSON.parse(res)
		
		$('form.cart').removeClass('loading');

		$('form.cart .loading-container').attr('loading', false);

		if(response.valid) {
			floatingCart.open()
			floatingCart.refresh( () => floatingCart.close(2000) )
		}
	}

	
	let fauxVariations = () => {
		let bindEl = $el => {	

			let data = {
				get $value(){
					/**
						Value is the current value of the $select element
					*/
					return data.$select.value
				},
				get $select(){
					/**
						$Select is the target woo select this is bound to
					*/
					return document.querySelector(`select[data-attribute_name='attribute_${data.attribute_name}']`)
				},
				get attribute_name() {
					return $el.getAttribute('data-attribute_name')
				},
				get attribute_value(){
					return $el.getAttribute('data-attribute_value')
				},
				click(){
					$(data.$select)
						.val(data.attribute_value)
						.trigger('change')
				},
				validateIsAvailable(){
					let validValues = Array.from(data.$select.options)
						.map(e => {
							return e.value
						})
					if( !validValues.includes(data.attribute_value) ) {
						return $el.classList.add('disabled')
					}
					$el.classList.remove('disabled')
				},
				inputChange(){
					
					data.validateIsAvailable()
					let { 
						$value,
						attribute_value
					} = data

					data.setOff()

					if($value == '') return;
					if($value == attribute_value) data.setOn()
					
				},
				setOn(){
					$el.classList.add('active')
				},
				setOff() {
					$el.classList.remove('active')
				}
			}
			$el.addEventListener('click', data.click)
			$(data.$select).on('change', data.inputChange)
			/**
				firing to init it.
			*/
			data.inputChange()
			return data;
		}

		let variations = $('.faux-variation-button');

		let elements = variations.map((k, $el) => bindEl($el) )
		

		let revalidateOptions = () => {
			/**
				"Debouncing" so the input events have time to trigger before checking
			*/
			setTimeout(() =>  elements.map( (k, $el) => $el.validateIsAvailable() ), 1);
		}

		$('select[data-attribute_name]').each((k, e) => $(e).on('change', revalidateOptions ) )
		
	}
	fauxVariations()


	// const swiper = new Swiper('.swiper', {
	const swiper = new Swiper('.swiper', {
		// Optional parameters
		// direction: 'vertical',
		loop: true,
		// slidesPerView: 5,
		// spaceBetween: 20,
		setWrapperSize: true,

		slidesPerView: 2,
		centeredSlides: true,
		spaceBetween: 30,

		// slideClass: 'single-product'
		// If we need pagination
		// pagination: {
		//   el: '.swiper-pagination',
		// },
	  
		// // Navigation arrows
		navigation: {
		  nextEl: '.swiper-button-next',
		  prevEl: '.swiper-button-prev',
		},

		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 20,
				centeredSlides: false
			},
			992: {
				slidesPerView: 4,
				spaceBetween: 20,
				centeredSlides: false
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 20,
				centeredSlides: false
			}
		}
	  
		// // And if we need scrollbar
		// scrollbar: { 
		//   el: '.swiper-scrollbar',
		// },
	});

	/**
		This module handles showing the price above the add to cart button. 
		It takes the price of the selected variation and accumulates a new price
		based on that and the calculated cost of the customizations. It 
	*/
	let customizationPriceModule = {

		formatter: new Intl.NumberFormat('en-NZ', {
			style: 'currency',
			currency: 'NZD',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		} ),

		init: () => {
			$(document.body).on('.product-customization-input input', customizationPriceModule.calculateTotal )
			/**
				Binds on event woo fires when all variation options are set and a variation is selected
			*/
			$( ".single_variation_wrap" ).on( "show_variation", customizationPriceModule.calculateTotal )
		},

		calculateTotal: () => {
			
			let elements = document.querySelectorAll('.product-customization-input')
			
			var $priceEl = document.querySelectorAll('.woocommerce-variation-price .woocommerce-Price-amount')

			if( elements.length == 0  || $priceEl.length == 0 )  {
				return
			}

			$priceEl = $priceEl[0]

			let $placeHolderEl = $priceEl.querySelector('.dynamic-price')

			var total = parseFloat( $priceEl.getAttribute('data-price') )

			elements.forEach(function(element) {

				let o = {
					length: element.value.length,
					chargeBy: element.getAttribute('data-charge-by').toLowerCase().replace(" ", '-'),
					required: element.getAttribute('data-required'),
					price: element.getAttribute('data-price'),
				} 

				let map = {
					"flat-rate" : _ => {
						if( o.length === 0 && o.required != 'required' ) {
							return
						}
						total+= parseFloat(o.price)
					},
					"character" : _ => {
						total+= parseFloat(o.price) * parseFloat(o.length)
					}
				}
				let cb  = map[o.chargeBy] ?? false
				if( cb ) {
					cb( )
				}
			} ) 

			$placeHolderEl.innerHTML = customizationPriceModule.formatter.format( parseFloat(total) )

		}

	}

	customizationPriceModule.init()	 

	$('.dropdown-menu > li > .dropdown-menu').parent().addClass('dropdown-submenu').find(' > .dropdown-item').attr('href', 'javascript:;').addClass('dropdown-toggle');
	$('.dropdown-submenu > a').on("click", function(e) {
	var dropdown = $(this).parent().find(' > .show');
		$('.dropdown-submenu .dropdown-menu').not(dropdown).removeClass('show');
		$(this).next('.dropdown-menu').toggleClass('show');
		e.stopPropagation();
	});
	$('.dropdown').on("hidden.bs.dropdown", function() {
		$('.dropdown-menu.show').removeClass('show');
	});
} )();